import { instanaReportError } from '@bizzabo/instana-api';

export const onAppToolGeneralErrorHandler = (error: Error, info: { componentStack: string }) => {
    instanaReportError(error, { componentStack: info.componentStack });
};
